export const GET_PROJECT_HISTORY = "GET_PROJECT_HISTORY"
export const GET_PROJECT_HISTORY_FAIL = "GET_PROJECT_HISTORY_FAIL"
export const SET_FAIL_MESSAGE_HISTORY = "SET_FAIL_MESSAGE_HISTORY"
export const LOADING_PROJECT_HISTORY = "LOADING_PROJECT_HISTORY"



export const GET_USER_HISTORY = "GET_USER_HISTORY"
export const GET_USER_HISTORY_FAIL = "GET_USER_HISTORY_FAIL"
export const SET_FAIL_MESSAGE_HISTORY_USER = "SET_FAIL_MESSAGE_HISTORY_USER"